// 커버

// 로고 변경
export const CHANGE_LOGO = 'survey/modules/cover/CHANGE_LOGO'
// 애니메이션 변경
export const CHANGE_ANIMATION = 'survey/modules/cover/CHANGE_ANIMATION'
// 커버 높이 변경
export const CHANGE_COVER_HEIGHT = 'survey/modules/cover/CHANGE_COVER_HEIGHT'
// 모두 변경
export const CHANGE = 'survey/modules/cover/CHANGE'

const initState: { src: string; animation: string, cover_height: number } = {
    src: '',
    animation: '',
    cover_height: 50
}

export default (state = initState, action: { type: string, src?: string, animation?: string, cover_height?: number }) => {
    switch(action.type) {
        case CHANGE_LOGO:
            return { ...state, src: action.src }
        case CHANGE_ANIMATION:
            return { ...state, animation: action.animation }
        case CHANGE_COVER_HEIGHT:
            return { ...state, cover_height: action.cover_height }
        case CHANGE:
            return { src: action.src, animation: action.animation, cover_height: action.cover_height || 50 }
        default:
            return state
    }
}